<script setup>
// Document-global SVG clipPath defs for the 2026 shard shapes.
//
// Mounted ONCE, from app.vue. These are `id`-addressed and referenced as
// `clip-path: url(#shard-1)`, so rendering them per-block would emit duplicate
// ids whenever two shard blocks share a page — invalid HTML, and url(#id)
// silently binds to whichever came first.
//
// SVG clipPath, never mask-image: PostCSS strips mask-image in this project.
</script>

<template>
    <svg class="absolute w-0 h-0" aria-hidden="true" focusable="false">
        <defs>
            <clipPath id="shard-1" clipPathUnits="objectBoundingBox">
                <path d="M 0.8265 0.9968 L 0.0444 0.8670 C 0.0136 0.8619 -0.0066 0.8174 0.0020 0.7738 L 0.1117 0.2214 C 0.1169 0.1950 0.1318 0.1751 0.1502 0.1699 L 0.7456 0.0013 C 0.7684 -0.0051 0.7911 0.0122 0.8007 0.0431 L 0.9954 0.6750 C 1.0031 0.7000 1.0007 0.7291 0.9891 0.7506 L 0.8714 0.9693 C 0.8607 0.9892 0.8437 0.9996 0.8265 0.9968 Z" />
            </clipPath>
            <clipPath id="shard-2" clipPathUnits="objectBoundingBox">
                <path d="M 0.8347 0.9283 L 0.2234 0.9985 C 0.2019 1.0009, 0.1818 0.9832, 0.1734 0.9544 L 0.0040 0.3778 C -0.0057 0.3448, 0.0026 0.3065, 0.0236 0.2876 L 0.3291 0.0110 C 0.3402 0.0010, 0.3536 -0.0024, 0.3664 0.0017 L 0.9600 0.1913 C 0.9883 0.2004, 1.0054 0.2422, 0.9974 0.2826 L 0.8789 0.8761 C 0.8731 0.9051, 0.8555 0.9259, 0.8347 0.9283 Z" />
            </clipPath>
            <clipPath id="shard-3" clipPathUnits="objectBoundingBox">
                <path d="M 0.7938 0.9982 L 0.1767 0.9486 C 0.1607 0.9473, 0.1460 0.9351, 0.1373 0.9157 L 0.0081 0.6280 C -0.0058 0.5971, -0.0014 0.5560, 0.0184 0.5326 L 0.4541 0.0165 C 0.4678 0.0002, 0.4864 -0.0044, 0.5031 0.0043 L 0.9643 0.2448 C 0.9903 0.2584, 1.0039 0.2996, 0.9946 0.3372 L 0.8439 0.9501 C 0.8364 0.9803, 0.8160 0.9994, 0.7938 0.9982 Z" />
            </clipPath>
            <clipPath id="cta-shard" clipPathUnits="objectBoundingBox">
                <path d="M0.2045,0.0026 L0.7928,0.1712 L0.7922,0.1712 C0.8308,0.1823 0.8612,0.2251 0.8717,0.2824 L0.9980,0.9868 C0.9988,0.9912 0.9994,0.9956 1,1 L0,1 L0,0.1944 L0.1187,0.0377 C0.1426,0.0069 0.1742,-0.0060 0.2045,0.0026" />
            </clipPath>
            <clipPath id="countdown-shard" clipPathUnits="objectBoundingBox">
                <path d="M0.65256,0.00428L0.11355,0.25551C0.1003,0.26169,0.08929,0.27414,0.08269,0.29041L0,0.49423L0.00001,0.99944H0.97514L0.99908,0.76066C1.00059,0.74555,0.9985,0.7302,0.99308,0.71671L0.72132,0.03947C0.70827,0.00697,0.67897,-0.00803,0.65256,0.00428Z" />
            </clipPath>
        </defs>
    </svg>
</template>
